<template>
  <div></div>
</template>

<script>
export default {
  async created() {
    if (this.$msal.isAuthenticated()) {
      if (
        this.$store.state.roles?.includes(
          "RH.MS.FieldUser"
        )
      ) {
        this.$router.push({
          path: "SurgicalCases",
        });
      } else if (
        this.$store.state.roles?.includes(
          "RH.MS.InhouseUser"
        )
      ) {
        this.$router.push({
          path: "TreatmentPlanRequests",
        });
      } else if (
        this.$store.state.roles?.includes(
          "RH.MS.AdminUser"
        )
      ) {
        this.$router.push({
          path: "AdminArea",
        });
      }
    } else {
      this.$router.push({
        path: "SignIn",
      });
    }
  },
};
</script>

<style>
</style>